<div class="inicio-wrap">
  <header class="inicio-header">
    <img src="assets/images/Augajo/logo.png" alt="Inversiones Augajo" class="inicio-logo">
  </header>

  <main class="inicio-main">
    <!-- Izquierda: texto + tarjetas -->
    <div class="inicio-izq">
      <div class="inicio-intro">
        <h1>Sistema de pedidos</h1>
        <p>Generación, seguimiento y administración de pedidos. Elige por dónde quieres empezar.</p>
      </div>

      <div class="accesos">
        <div class="acceso" (click)="navegar('vendedor')">
          <div class="acceso-icono"><mat-icon>shopping_cart</mat-icon></div>
          <div class="acceso-texto">
            <h3>Generar Pedido</h3>
            <p>Crea y registra nuevos pedidos de clientes.</p>
          </div>
          <mat-icon class="acceso-flecha">arrow_forward</mat-icon>
        </div>

        <div class="acceso" (click)="navegar('admin')">
          <div class="acceso-icono"><mat-icon>admin_panel_settings</mat-icon></div>
          <div class="acceso-texto">
            <h3>Administración</h3>
            <p>Gestiona catálogos, usuarios y reportes.</p>
          </div>
          <mat-icon class="acceso-flecha">arrow_forward</mat-icon>
        </div>
      </div>
    </div>

    <!-- Derecha: ilustración -->
    <div class="inicio-der">
      <img src="../../assets/images/undraw_deliveries_qutl.svg" alt="" class="inicio-ilustracion">
    </div>
  </main>

  <footer class="inicio-footer">
    © 2026, Inversiones Augajo · Todos los derechos reservados
  </footer>
</div>